import { CoffeeMakerCheckIcon } from './CoffeeMakerCheckIcon';

/**
 * author: Michael Irigoyen
 * id A82510E6-E7E7-4E2C-96A6-E041EFC72897
 * name coffee-maker-check
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-maker-check.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const CoffeeMakerCompleteIcon = CoffeeMakerCheckIcon;
export default CoffeeMakerCompleteIcon